import { Position, State } from 'src/types'
// 背面の描画
import { indexFingerCover } from 'src/features/gorilla/drawer/glove/rightThrow/back/fingerCoverOrPad/indexFingerCover'
import { lace } from 'src/features/gorilla/drawer/glove/rightThrow/back/lace'
import { lining } from 'src/features/gorilla/drawer/glove/rightThrow/back/lining'
import { littleHookDrawer } from 'src/features/gorilla/drawer/glove/rightThrow/back/hooks/littleHook'
import { thumbHook } from 'src/features/gorilla/drawer/glove/rightThrow/back/hooks/thumbHook'
import { backLaceDrawer, gorillaLabelDrawerForGloveLeftThrow } from 'src/features/gorilla/drawer/common/useCanvasHelper'
import { webOfGloveBackDrawer } from 'src/features/gorilla/drawer/glove/rightThrow/back/web/useCanvasWebsBack'
import { indexFingerCoverTipOut } from 'src/features/gorilla/drawer/glove/rightThrow/back/fingerCoverOrPad/indexFingerCoverTipOut'
import { laceOfWristBeltCrossDrawer } from 'src/features/gorilla/drawer/glove/rightThrow/back/lace/laceOfWristBeltFix'
import { canvasResetter } from 'src/util/canvas'
import { liningEmbroideryDrawerLeftThrow, nonThumbEmbroideryDrawerLeftThrow, startInversion, undoInversion } from 'src/util/canvas'
import { backStyleOfGloveBackDrawerLeftThrow } from './backStyles'

export const gorillaCanvasGloveBackLeftThrow = (ctx: CanvasRenderingContext2D, state: State, position: Position, canvasWidth: number): void => {
  const isIndexFingerCover = state.fingerGuardType?.value == 'indexCover' || (state.fingerGuardType?.value === 'unselected' && position === 'pitcher')
  const isIndexAndMiddleFingerTipOutCover = state.fingerGuardType?.value === 'indexAndMiddleTipOutCover'
  const isMiddleFingerTipOutCover = state.fingerGuardType?.value === 'middleTipOutCover'
  // リセット
  canvasResetter(ctx)

  startInversion(ctx, canvasWidth)
  // 裏革
  lining(ctx, state.linings?.color)

  undoInversion(ctx, canvasWidth)
  // 平裏の刺繍描画1段目
  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'first')
  // 平裏の刺繍描画2段目
  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'second')

  // バックスタイルの描画(ハミダシ,親指刺繍含)
  backStyleOfGloveBackDrawerLeftThrow(ctx, state, canvasWidth)

  startInversion(ctx, canvasWidth)
  // 指カバー
  isIndexFingerCover && indexFingerCover(ctx, state.indexCover.color, state.stitch.color)
  isIndexAndMiddleFingerTipOutCover && indexFingerCoverTipOut(ctx, state.indexCover.color, state.stitch.color, -90, 70, -10)
  isMiddleFingerTipOutCover && indexFingerCoverTipOut(ctx, state.indexCover.color, state.stitch.color, -155, 85, -13)
  undoInversion(ctx, canvasWidth)

  // 中指への刺繍
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'middleFinger', state.embroideries)
  // 薬指への刺繍
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'ringFinger', state.embroideries)
  // 小指への刺繍
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'childFinger', state.embroideries)

  startInversion(ctx, canvasWidth)
  // ウェブの描画
  webOfGloveBackDrawer(ctx, state, position)
  // 革紐
  lace(ctx, state.lace?.color)

  laceOfWristBeltCrossDrawer(ctx, state.lace?.color, state.baseModel.productNumber)

  // 背面紐通し(オプション)
  backLaceDrawer(ctx, state?.backLace?.value, state.lace?.color, position)
  // 小指掛け紐
  littleHookDrawer(ctx, state.littleHook?.color, state.baseModel?.productNumber)
  undoInversion(ctx, canvasWidth)
  // ラベル描画
  gorillaLabelDrawerForGloveLeftThrow(ctx, state)

  startInversion(ctx, canvasWidth)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元

  undoInversion(ctx, canvasWidth)
}
